export class JackpotData {
    static DataCode: string = "code";
    static DataHighestWinDate: string = "highestWinDate";
    static DataHighestWinAmount: string = "highestWinAmount";
    static DataWinCount: string = "winCount";
    static DataLastWinDate: string = "lastWinDate";
    static DataLastWinAmount: string = "lastWinAmount";
    static DataNoWins: string = "noWins";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Datas/JackpotData.ts
 **/